import { useApolloClient } from '@apollo/client';
import type Quill from 'quill/core';
import type { Parchment } from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import mentionIcon from '../../icons/non-prefilled/16x16/mention.svg';
import Attachment from '../formats/Attachment';
import FileBlot from '../formats/FileBlot';
import fetchPostAnchorTitle from '../utils/fetchPostAnchorTitle';
import replaceEmbedBlotWith from '../utils/replaceEmbedBlotWith';

type ConvertIntoMentionMenuItemProps = {
  quill: Quill;
} & (
  | {
      blot: Parchment.EmbedBlot;
      type: string;
      id: string;
      params?: string;
    }
  | {
      blot: Attachment;
      type?: never;
      id?: never;
      params?: never;
    }
  | {
      blot: FileBlot;
      type?: never;
      id?: never;
      params?: never;
    }
);

const ConvertIntoMentionMenuItem = ({
  quill,
  ...props
}: ConvertIntoMentionMenuItemProps) => {
  const apollo = useApolloClient();

  return (
    <MenuItem
      icon={mentionIcon}
      onClick={async () => {
        if (props.blot instanceof Attachment) {
          replaceEmbedBlotWith(
            quill,
            props.blot,
            {
              'attachment-mention': props.blot.getAttachmentFiles(),
            },
            props.blot.formats(),
          );
          return;
        }

        if (props.blot instanceof FileBlot) {
          replaceEmbedBlotWith(
            quill,
            props.blot,
            {
              'attachment-mention': [props.blot.getAsAttachmentFile()],
            },
            props.blot.formats(),
          );
          return;
        }

        const { blot, type, id, params } = props;
        let attributes;
        if (type === 'post') {
          const title = await fetchPostAnchorTitle(apollo, id);
          if (title) {
            attributes = { 'mention-text': title };
          }
        }
        replaceEmbedBlotWith(
          quill,
          blot,
          { mention: { type, id, params } },
          attributes,
        );
      }}
      testId="convertIntoMentionMenuItem"
    >
      Convert into mention
    </MenuItem>
  );
};

export default ConvertIntoMentionMenuItem;
